import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import { getStudentDashboardOptions } from "@/client/@tanstack/react-query.gen"
import Dashboard from "@/routes/-pages/Dashboard"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/dashboard")({
  loader: () => {
    return runBackendModePrefetch(() => queryClient.prefetchQuery(getStudentDashboardOptions()))
  },
  component: Dashboard,
})
